/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scheduledDependencyResponseSchema = z.object({
  createdAt: z.iso.datetime().nullish(),
  createdBy: z.string(),
  dependencyItemId: z.int(),
  dependencyItemType: z.enum(['SUCCESSOR', 'PREDECESSOR']),
  dependencyStatus: z.enum(['UNSCHEDULED', 'CIRCULAR', 'ACTIVE', 'CLIPPED', 'SATISFIED']).nullish(),
  forecastedFinish: z.iso.datetime().nullish(),
  id: z.int(),
  itemId: z.int().nullish(),
  updatedAt: z.iso.datetime().nullish(),
  updatedBy: z.string(),
  waitDays: z.int().nullish(),
});
